export default function roomEventListener(room) {
  return store => {
    room.addEventListeners({
        room_media_add: e => {
            store.commit('media/ADD_ROOM_MEDIA_FILE', e.data)
        },
        room_media_remove: e => {
            store.commit('media/REMOVE_ROOM_MEDIA_FILE', e.data)
        },
        room_media_change: e => {
            store.commit('media/CHANGE_ROOM_MEDIA', e.data)
        }
    });
  }
}
